<div style="overflow-y:auto; height: 100%; padding-right: 24px; overflow-x:hidden;">
  <div nz-row nzGutter="12">
    <nz-divider nzText="Thông tin lương" nzOrientation="left" nzPlain ></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Số quyết định</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày quyết định</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày hiệu lực</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày nâng lương</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">TL lương căn bản</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Hệ số chức vụ</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">TL vượt khung</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">TL ưu đãi</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Hệ số trách nhiệm</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Mức lương</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Mức phụ cấp thu hút nghề</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Mức phụ cấp thâm niên</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Mức phụ cấp chức vụ lãnh đạo</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div>
    <nz-divider nzText="Diễn biến hợp đồng" nzOrientation="left" nzPlain ></nz-divider>
    <nz-table #basicTable [nzData]="listOfData" class="w-full" [nzScroll]="{x: '1500px'}">
      <thead>
        <tr>
          <th>STT</th>
          <th>Số QĐ</th>
          <th>Ngày QĐ</th>
          <th>Ngày hiệu lực</th>
          <th>Ngạch</th>
          <th>Bậc</th>
          <th>Hệ số</th>
          <th>Mức lương</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index;">
          <td>{{ i+1 }}</td>
          <td>{{ data.sqd }}</td>
          <td>{{ data.nqd }}</td>
          <td>{{ data.nhl }}</td>
          <td>{{ data.ngach }}</td>
          <td>{{ data.lqd }}</td>
          <td>{{ data.bac }}</td>
          <td>{{ data.heso }}</td>
          <td>{{ data.luong }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>